module.exports = __webpack_public_path__ + "static/media/area-do-inquilino.e5d11cb3.webp";